/** @format */

import {useState} from 'react';

import {Box} from '@mui/material';

import {Trans} from 'react-i18next';

import {ROUTES} from 'constants/ROUTES';
import Breadcrumbs from 'components/Breadcrumbs';

import {PeriodSelectorLite} from 'components/PeriodSelectorLite';

import {usePeriodSelectorLite} from 'components/PeriodSelectorLite/usePeriodSelectorLite';

import {useCompanyContext} from 'contexts/CompanyContext';

import {platformsFromAdType} from 'helpers/adTypeHelpers';

import {DEFAULT_PERIOD, PERIODS_MODEL} from './constants';
import {ReportsTable} from './components/ReportsTable';
import {BreadcrumbsBox, TableContainer} from './styles';
import {mapTableData} from './helpers/mapTableData';
import {useGetCurrentUserQuery} from './graphql/__generated__';

const Reports = () => {
  const [now] = useState(() => new Date());

  const {startDate, endDate, currentPeriod, onPeriodClick} = usePeriodSelectorLite({
    now,
    defaultPeriod: DEFAULT_PERIOD,
  });

  const {loading, error, data} = useGetCurrentUserQuery();

  const {currentAdType} = useCompanyContext();

  if (loading || error || !data?.currentUser?.currentCompany) {
    return null;
  }

  const breadcrumbs = [
    {
      href: ROUTES.INDEX,
      title: <Trans>Проекты</Trans>,
    },
    {
      href: `/${ROUTES.HOME}`,
      title: <Trans>{data.currentUser.currentCompany.name}</Trans>,
    },
    {
      href: '',
      title: <Trans>Отчёты</Trans>,
    },
  ];

  const platforms = platformsFromAdType(currentAdType);

  const reportTableData = mapTableData({
    data,
    startDate,
    endDate,
    platforms,
  });

  return (
    <Box>
      <BreadcrumbsBox>
        <Breadcrumbs items={breadcrumbs} />
      </BreadcrumbsBox>
      <PeriodSelectorLite
        model={PERIODS_MODEL}
        onPeriodClick={onPeriodClick}
        currentPeriod={currentPeriod}
      />
      <TableContainer>
        <ReportsTable data={reportTableData} />
      </TableContainer>
    </Box>
  );
};

export {Reports};
